import { getEnvParam } from "@/env";

export interface PlacePriceTypeRow {
    property_type: string;
    average_price: number;
    median_price: number;
    min_price: number;
    max_price: number;
    count: number;
    percentage_of_sales: number;
}

export interface PlacePriceHistogramBin {
    min: number;
    max: number;
    count: number;
}

export interface PlacePriceDistribution {
    place_id: number;
    place_name: string | null;
    place_level: number | null;
    overall_average: number | null;
    overall_median: number | null;
    total_sales: number;
    by_property_type: PlacePriceTypeRow[];
    histogram: PlacePriceHistogramBin[];
}

export async function getPlacePriceDistribution(
    placeId: number,
): Promise<PlacePriceDistribution> {
    const result = await fetch(
        `${process.env.BUN_PUBLIC_TILE_SERVER}/api/finance/places/${placeId}/distribution?${getEnvParam()}`,
        {
            headers: {
                "X-API-KEY": process.env.BUN_PUBLIC_TILE_SERVER_API_KEY,
            },
        },
    );
    if (!result.ok) {
        throw new Error(`Failed to fetch place distribution: ${result.status}`);
    }
    return result.json();
}
